import React from 'react';
import { Linkedin, Mail } from 'lucide-react';

const CorporateFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0F172A] border-t border-white/10 py-12" data-testid="corporate-footer">
      <div className="container mx-auto px-4 sm:px-8 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand Column */}
          <div>
            <h3 className="text-xl font-bold text-white mb-4 font-heading">
              Vijay Kadechkarr
            </h3>
            <p className="text-sm text-slate-400 font-body leading-relaxed">
              Head of Productions | Vertical Head | Business Head | Strategic Business Consultant
            </p>
            <p className="text-sm text-slate-400 font-body leading-relaxed mt-2">
              Media & Entertainment | Film | Television | Talent | Production | Business Development
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base font-semibold text-white mb-4 font-heading">
              Quick Links
            </h4>
            <div className="space-y-2">
              {['Profile', 'Domains', 'Career', 'Contact'].map((link) => (
                <button
                  key={link}
                  onClick={() => {
                    const element = document.querySelector(`#${link.toLowerCase()}`);
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                  className="block text-sm text-slate-400 hover:text-rose-500 transition-colors font-body"
                  data-testid={`footer-link-${link.toLowerCase()}`}
                >
                  {link}
                </button>
              ))}
            </div>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-base font-semibold text-white mb-4 font-heading">
              Connect
            </h4>
            <div className="flex gap-4">
              <a
                href="mailto:executive@vijaykadechkar.com"
                className="w-10 h-10 bg-rose-500/10 rounded-lg flex items-center justify-center hover:bg-rose-500/20 transition-colors"
                data-testid="footer-email"
              >
                <Mail className="text-rose-500" size={20} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-rose-500/10 rounded-lg flex items-center justify-center hover:bg-rose-500/20 transition-colors"
                data-testid="footer-linkedin"
              >
                <Linkedin className="text-rose-500" size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-white/10 text-center">
          <p className="text-sm text-slate-500 font-body">
            © {currentYear} Vijay Kadechkarr. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default CorporateFooter;
